import getHttpFetch from './src/httpFetch';

export default getHttpFetch("", window.baseUrl ? window.baseUrl : null);
export const loginFetch = getHttpFetch("", 'url');